import { TEDCustomNumberDisplayer } from './TEDCustomNumberDisplayer';
import { TEDParseNumberMode } from '../FormatterTypes';

class TEDDisplayInt64 extends TEDCustomNumberDisplayer {
  public static getInstance() {
    return this.instance ? this.instance : (this.instance = new this());
  }

  private static instance: TEDDisplayInt64;

  public mode() {
    return TEDParseNumberMode.pnmInt64;
  }
}

export { TEDDisplayInt64 };
